import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { AgeRatingClient, AgeRatingDto } from 'src/app/core/services/service-clients';
import { firstValueFrom } from 'rxjs';

interface AgeRatingState {
  ageRatings: AgeRatingDto[];
  loading: boolean;
}

const initialState: AgeRatingState = {
  ageRatings: [],
  loading: false,
};

export const ageRatingStore = signalStore(
  withState<AgeRatingState>(initialState),

  withMethods((store) => {
    const ageRatingClient = inject(AgeRatingClient);

    return {
      async loadAgeRatings() {
        patchState(store, { loading: true });
        try {
          const ageRatings = await firstValueFrom(ageRatingClient.get());
          patchState(store, { ageRatings, loading: false });
        } catch {
          patchState(store, { loading: false });
          return false;
        }
        return true;
      },

      async addAgeRating(ageRating: AgeRatingDto) {
        patchState(store, { loading: true });
        try {
          const ageRatings = await firstValueFrom(ageRatingClient.post(ageRating));
          patchState(store, { ageRatings, loading: false });
        } catch {
          patchState(store, { loading: false });
          return false;
        }
        return true;
      },

      async updateAgeRating(ageRating: AgeRatingDto) {
        patchState(store, { loading: true });
        try {
          const ageRatings = await firstValueFrom(ageRatingClient.put(ageRating));
          patchState(store, { ageRatings, loading: false });
        } catch {
          patchState(store, { loading: false });
          return false;
        }
        return true;
      },

      async deleteAgeRating(ageRatingId: number) {
        patchState(store, { loading: true });
        try {
          const ageRatings = await firstValueFrom(ageRatingClient.delete(ageRatingId));
          patchState(store, { ageRatings, loading: false });
        } catch {
          patchState(store, { loading: false });
          return false;
        }
        return true;
      }
    };
  })
);
